<style>
.el-transfer-panel {
    width: 37%;
}

.el-transfer .el-transfer-panel .el-checkbox-group > label {
    display: block;
}

#PacketCodesCol .el-checkbox__input.is-indeterminate .el-checkbox__inner {
    background-color: #409eff;
    border-color: #409eff;
}
</style>

<template>
    <div class="addMain wraper">
        <template>
            <el-backtop target=".wraper"></el-backtop>
        </template>
        <div class="returnBtn" @click="goBack()">
            <i class="el-icon-back"></i>
        </div>
        <el-breadcrumb class="crumbs" separator-class="el-icon-arrow-right">
            <el-breadcrumb-item v-for="(item,index)  in routeList" :key="index" :to="{ name: item.name,query:{id:item.query.id,flag:item.query.flag,name:item.query.name} }">
                {{item.name}}
            </el-breadcrumb-item>
        </el-breadcrumb>
        <el-card shadow="never">
            <div class="cardTop">
                <h1 v-if="flag != 'edit'">创建kafka推送服务</h1>
                <h1 v-if="flag == 'edit'">更新kafka推送服务</h1>
            </div>
            <div class="cardBottom">
                <div class="addIntroduce">
                    <h3 v-if="flag != 'edit'">填写kafka推送服务的信息。
                        <!-- <br />kafka默认<span style="font-weight: bold;color: #ff3d47">登录的用户名、密码为appKey和appSecret，vhost为appKey</span>，可前往<router-link style="color:#409eff" :to="{path:'/user/userPersonal'}">个人信息页</router-link>查看相关参数。 -->
                    </h3>
                    <h3 v-if="flag == 'edit'">更新kafka推送服务的信息。
                        <!-- <br />kafka默认<span style="font-weight: bold;color: #ff3d47">登录的用户名、密码为appKey和appSecret，vhost为appKey</span>，可前往<router-link style="color:#409eff" :to="{path:'/user/userPersonal'}">个人信息页</router-link>查看相关参数。 -->
                    </h3>
                </div>
                <el-form ref="addForm" :model="addForm" :rules="rules">
                    <el-form-item label="kafka推送服务名称" prop="name"><br />
                        <div class="subheading">输入kafka推送服务名称。</div>
                        <el-input v-model="addForm.name" placeholder="请输入" maxlength="100"></el-input>
                    </el-form-item>
                    <el-form-item label="推送主题（topic）" prop="topic"><br />
                        <div class="subheading">输入推送主题（topic），仅支持输入字母、数字及下划线组成的字符串,主题要求用户下唯一。</div>
                        <el-input v-model="addForm.topic" placeholder="请输入" maxlength="255" v-if="flag != 'edit'"></el-input>
                        <el-input v-model="addForm.topic" placeholder="请输入" maxlength="255" v-if="flag == 'edit'" disabled="true">
                        </el-input>
                    </el-form-item>
                    <!-- <el-form-item label="缓存过期时间（s）" prop="expirationTime"><br />
                        <div class="subheading">缓存过期时间，指消息在队列中的缓存时间，超时后消息将会被丢弃，其占用的空间也会被释放。<span style="margin-left:5px;color:#E6A23C">要求缓存时间在30s - 604800s（7天）之内</span></div>
                        <el-input v-model.number="addForm.expirationTime" type="number" placeholder="请输入缓存过期时间">
                            <template slot="append">秒</template>
                        </el-input>
                        <span style="margin-left:30px;line-height:40px;height:40px; margin-top:10px;display:inline-block;">
                            快速输入：
                            <el-link :underline="false" type="primary" @click="addForm.expirationTime = 30">30 秒</el-link>
                            <el-link style="margin-left:18px" :underline="false" type="primary" @click="addForm.expirationTime = 300">
                                5分钟</el-link>
                            <el-link style="margin-left:18px" :underline="false" type="primary" @click="addForm.expirationTime = 3600">1小时</el-link>
                            <el-link style="margin-left:18px" :underline="false" type="primary" @click="addForm.expirationTime = 86400">1&nbsp;天</el-link>
                            <el-link style="margin-left:18px" :underline="false" type="primary" @click="addForm.expirationTime = 604800">1&nbsp;周</el-link>
                        </span>
                    </el-form-item> -->
                    <el-form-item label="密钥" prop="pushKey"><br />
                        <div class="subheading">密钥用于推送数据加密。</div>
                        <el-input v-model="addForm.pushKey" placeholder="请输入" maxlength="255"></el-input>
                    </el-form-item>
                    <el-form-item label="推送类型" prop="pushType"><br />
                        <el-checkbox-group v-model="addForm.pushType">
                            <el-checkbox label="1" name="pushType">数据推送</el-checkbox>
                            <el-checkbox label="2" name="pushType">在线离线推送</el-checkbox>
                            <el-checkbox label="3" name="pushType">告警推送</el-checkbox>
                        </el-checkbox-group>
                        <br />
                    </el-form-item>
                    <el-form-item label="指定设备类型" prop="deviceType"><br />
                        <el-radio-group v-model="addForm.deviceType">
                            <el-radio :label="1">全部设备</el-radio>
                            <el-radio :label="2">设备分类所属设备</el-radio>
                            <el-radio :label="3">设备协议所属设备</el-radio>
                        </el-radio-group>
                        <br />
                    </el-form-item>

                    <el-form-item :label="addForm.deviceType == 2 ? '设备分类' : '设备协议'" prop="devicePro" v-if="addForm.deviceType != 1 "><br />
                        <el-transfer v-if="addForm.deviceType == 2" :props="{key: 'value'}" v-model="selectedCategory" :data="devCategoryList" :titles="['未选', '已选']"></el-transfer>
                        <el-transfer v-if="addForm.deviceType == 3" :props="{key: 'id',label: 'name'}" v-model="selectedProtocol" :data="devProtocolList" :titles="['未选', '已选']" @change="changeDevProtocol"></el-transfer>
                    </el-form-item>
                    <!--协议类型，需要过滤协议字段-->
                    <el-form-item label="推送协议功能" v-if="addForm.deviceType == 3" prop="proPacketCodes"><br />
                        <el-collapse accordion id="PacketCodesCol">
                            <el-collapse-item v-for="proPacketCode in proPacketCodes" :key="proPacketCode.protocolId">
                                <template slot="title">
                                    <el-checkbox style="margin-right:3%" :indeterminate="proPacketCode.isIndeterminate" v-model="proPacketCode.checkAll" @change="handleCheckAllChange(proPacketCode)">全选</el-checkbox>
                                    {{proPacketCode.protocolName}}
                                </template>
                                <el-checkbox-group v-model="proPacketCode.checkedPacketCodes" @change="handleCheckedChange(proPacketCode)">
                                    <el-checkbox v-for="packetCode in proPacketCode.packetCodes" :label="packetCode" :key="packetCode">
                                    </el-checkbox>
                                </el-checkbox-group>
                            </el-collapse-item>
                        </el-collapse>
                    </el-form-item>

                    <el-form-item label="状态" prop="enable"><br />
                        <el-radio-group v-model="addForm.enable">
                            <el-radio :label="1">启用</el-radio>
                            <el-radio :label="0">停用</el-radio>
                        </el-radio-group>
                        <br />
                    </el-form-item>
                    <el-form-item label="备注" prop="remarks"><br />
                        <el-input style="margin-top:5px;width:50%;" type="textarea" :rows="3" v-model="addForm.remarks" placeholder="请输入" maxlength="255"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="text" @click="$router.history.go(-1)">取消
                        </el-button>
                        <el-button v-if="flag != 'edit'" type="primary" @click="onSubmit('addForm')">创建kafka推送服务
                        </el-button>
                        <el-button v-if="flag == 'edit'" type="primary" @click="editOnSubmit('addForm')">更新kafka推送服务
                        </el-button>
                    </el-form-item>
                </el-form>
            </div>
        </el-card>
    </div>
</template>
<script>
import API from "../../api/api";

export default {
    data() {
        var checkExpirationTime = (rule, value, callback) => {
            if (isNaN(value)) {
                value = ''
                callback(new Error('输入有效数字。'));
            }
            if (30 > value || value > 604800) {
                callback(new Error('输入有效的缓存过期时间，限制30s-604800s(7天)。'));
            } else {
                callback();
            }
        };
        return {
            routeList: this.$route.meta.routeList,
            flag: this.$route.query.flag,
            rules: {
                name: [{
                    required: true,
                    message: "请输入kafka推送服务名称",
                    trigger: "blur"
                }],
                topic: [{
                    required: true,
                    message: "请输入kafka推送主题",
                    trigger: "blur"
                },
                {
                    pattern: /^[0-9a-zA-Z_.\-]{1,}$/,
                    message: '不合法的推送主题'
                }
                ],
                // expirationTime: [{
                //     required: true,
                //     message: "请输入缓存过期时间",
                //     trigger: "blur"
                // },
                // {
                //     validator: checkExpirationTime,
                //     trigger: 'change'
                // },
                // {
                //     validator: checkExpirationTime,
                //     trigger: 'blur'
                // }
                // ],
                pushType: [{
                    type: 'array',
                    required: true,
                    message: '请至少选择一个推送类型',
                    trigger: 'change'
                }],
            },
            addForm: {
                id: '',
                name: '',
                topic: '',
                expirationTime: '',
                pushKey: '',
                pushType: ['1'],
                enable: 1,
                remarks: '',
                deviceType: 1,
                pushMode: 3 //kafka推送
            },
            devCategoryList: [], //设备分类总列表
            selectedCategory: [], //:已选中分类列表
            devProtocolList: [], //设备协议总列表
            selectedProtocol: [], //:已选中协议列表
            proPacketCodes: [],
        };
    },
    created() { },
    methods: {

        //当页面为编辑状态flag==edit时要获取到当前编辑的信息
        getMage() {
            if (this.flag == "edit") {
                let id = this.$route.query.id;
                API.pushServiceGetById({
                    id
                }).then(res => {
                    if (res.code == 1) {
                        res.data.pushType = res.data.pushType.split(",")
                        var type = res.data.deviceType;
                        switch (type) {
                            case 2:
                                this.selectedCategory = res.data.deviceProId.split(",");
                                break;
                            case 3:
                                this.selectedProtocol = res.data.deviceProId.split(",");
                                let proPacketCodes = JSON.parse(res.data.proPacketCodes)
                                let arr = []
                                for (var key in proPacketCodes) {
                                    let json = {
                                        protocolId: key,
                                        checkedPacketCodes: proPacketCodes[key]
                                    }
                                    //获取协议全部包体
                                    API.platformDevProtocolViewPacketAndField(key, 1).then(res => {
                                        // 1代表上行包数据
                                        if (res.code == 1) {
                                            var packetCodes = res.data.map(function (v) {
                                                return v.code;
                                            });
                                            json.packetCodes = packetCodes;
                                            json.checkAll = packetCodes.length === proPacketCodes[json.protocolId].length;
                                            json.isIndeterminate = proPacketCodes[json.protocolId].length > 0 && proPacketCodes[json
                                                .protocolId].length < packetCodes.length;
                                            json.protocolName = this.devProtocolList.filter(function (v) {
                                                return v.id == json.protocolId;
                                            })[0].name
                                        }
                                        arr.push(json)
                                    });
                                }
                                this.proPacketCodes = arr
                                break;
                        }
                        this.addForm = res.data;
                    } else {
                        this.$message.error(res.msg);
                    }
                });
            }
        },
        getData() {
            this.getDevProtocolList();
            this.getDevCategory();
        },
        getDevProtocolList() {
            API.platformDevDeviceProtocol().then(res => {
                if (res.code == 1) {
                    this.devProtocolList = res.data;
                }
            });
        },
        getDevCategory() {
            //获取设备分类数据
            API.platformDevCategoryDevCategoryList().then(res => {
                if (res.code == 1) {
                    this.devCategoryList = res.data.devCategoryTreeList;
                }
            });
        },
        //创建服务推送
        onSubmit(formName) {
            let _this = this;
            let _API = API;
            var type = this.addForm.deviceType;
            this.addForm.deviceProId = type == 2 ? this.selectedCategory.join(",") : type == 3 ? this.selectedProtocol.join(
                ",") : ""
            this.$refs[formName].validate(valid => {
                if (valid) {
                    var json = JSON.parse(JSON.stringify(_this.addForm));
                    if (json.deviceType != 2) {
                        var packetCodesJson = {}
                        _this.proPacketCodes.map(function (v) {
                            packetCodesJson[v.protocolId] = v.checkedPacketCodes
                        });
                        json.proPacketCodes = JSON.stringify(packetCodesJson)
                    }
                    json.pushType = _this.addForm.pushType.join()
                    _API.pushServiceSave(json).then(res => {
                        if (res.code == 1) {
                            _this.$message({
                                message: "创建kafka推送服务成功",
                                type: "success"
                            });
                            _this.$router.push({
                                path: "/pushService/kafkaPushList"
                            });
                        } else {
                            _this.$message({
                                message: res.msg,
                                type: "error"
                            });
                        }
                    });
                } else {
                    _this.$message({
                        message: "请填写完所有必填项",
                        type: "error"
                    });
                    return false;
                }
            });
        },
        //更新设备
        editOnSubmit(formName) {
            let _this = this;
            let _API = API;
            var type = this.addForm.deviceType;
            this.addForm.deviceProId = type == 2 ? this.selectedCategory.join(",") : type == 3 ? this.selectedProtocol.join(
                ",") : ""
            this.$refs[formName].validate(valid => {
                if (valid) {
                    delete _this.addForm.createDate
                    delete _this.addForm.updateDate
                    delete _this.addForm.expireTime
                    delete _this.addForm.status
                    var json = JSON.parse(JSON.stringify(_this.addForm));
                    if (json.deviceType != 2) {
                        var packetCodesJson = {}
                        _this.proPacketCodes.map(function (v) {
                            packetCodesJson[v.protocolId] = v.checkedPacketCodes
                        });
                        json.proPacketCodes = JSON.stringify(packetCodesJson)
                    }
                    json.pushType = _this.addForm.pushType.join()
                    console.log(json);
                    json.pushType = _this.addForm.pushType.join()
                    _API.pushServiceSave(json)
                        .then(res => {
                            if (res.code == 1) {
                                _this.$message({
                                    message: "更新kafka推送服务成功",
                                    type: "success"
                                });
                                _this.$router.push({
                                    path: "/pushService/kafkaPushList"
                                });
                            } else {
                                _this.$message({
                                    message: res.msg,
                                    type: "error"
                                });
                            }
                        });
                } else {
                    _this.$message({
                        message: "请填写完所有必填项",
                        type: "error"
                    });
                    return false;
                }
            });
        },
        //协议穿梭框发生变化时
        changeDevProtocol(nowVal, changeType, changeVal) {
            //同步维护协议包体
            var proPacketCodes = this.proPacketCodes
            switch (changeType) {
                case "right": //增加
                    for (let i = 0; i < changeVal.length; i++) {
                        //判断是否存在
                        var proPacketCode = proPacketCodes.filter(function (v) {
                            return v.protocolId == changeVal[i];
                        })
                        if (proPacketCode.length > 0) {
                            continue;
                        } else {
                            //不存在该协议的包体列表时增加该协议全部包体
                            let packetCode = this.devProtocolList.filter(function (v) {
                                return v.id == changeVal[i];
                            })
                            var packetCodes = [];
                            //获取协议全部包体
                            API.platformDevProtocolViewPacketAndField(changeVal[i], 1).then(res => {
                                // 1代表上行包数据
                                if (res.code == 1) {
                                    packetCodes = res.data.map(function (v) {
                                        return v.code;
                                    });
                                    let newPacketCode = {
                                        protocolId: changeVal[i],
                                        protocolName: packetCode[0].name,
                                        checkAll: true,
                                        isIndeterminate: false,
                                        packetCodes: packetCodes,
                                        checkedPacketCodes: packetCodes
                                    }
                                    proPacketCodes.push(newPacketCode)
                                }
                            });
                        }
                    }
                    break;
                case "left": //减少
                    for (let i = 0; i < changeVal.length; i++) {
                        for (let j = 0; j < proPacketCodes.length; j++) {
                            //判断是否存在,存在则移除
                            if (proPacketCodes[j].protocolId == changeVal[i]) {
                                proPacketCodes.splice(j, 1)
                                break
                            }
                        }
                    }
                    break;
            }
        },
        //协议包体全选框
        handleCheckAllChange(packetCode) {
            packetCode.checkedPacketCodes = packetCode.checkAll ? packetCode.packetCodes : []
            packetCode.isIndeterminate = false;
        },
        handleCheckedChange(packetCode) {
            let checkedCount = packetCode.checkedPacketCodes.length;
            packetCode.checkAll = checkedCount === packetCode.packetCodes.length;
            packetCode.isIndeterminate = checkedCount > 0 && checkedCount < packetCode.packetCodes.length;
        }
    },
    mounted() {
        this.getData();
        this.getMage();
    }
};

</script>



// WEBPACK FOOTER //
// src/views/platform/kafkaPushAdd.vue